import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAiAnnotations = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 7,
	viewBox: "0 0 88 84",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M75.6 3.5v17.1M67 12.1h17.1M12 63.4v17.1m-8.6-8.6h17.1M43 3.5l9.8 29.3L77.2 42l-24.4 9.2L43 80.5l-9.8-29.3L8.8 42l24.4-9.2z" })
});
export default SvgAiAnnotations;
